import { render, staticRenderFns } from "./ConfirmationForm.vue?vue&type=template&id=4bccbfe4&scoped=true&"
import script from "./ConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bccbfe4",
  null
  
)

export default component.exports